<template>
  <div class="part-inventory-edit-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="600px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" :rules="rules" size="small" ref="form" label-position="top">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ru_ku_dan_hao')" prop="inBatchNum">
                <el-input v-model="form.inBatchNum"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ru_ku_shi_jian')" prop="inTime">
                <custom-date-picker style="width: 100%" v-model="form.inTime" type="date" :picker-options="pickerOptionDay"></custom-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ling_jian_lei_bie')" prop="partClass">
                <custom-select v-model="form.partClass" code="asm_part_class" @change="partClassChange"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ling_jian_lei_xing')" prop="partType">
                <custom-select v-model="form.partType" code="asm_part_type" @change="partTypeChange"></custom-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ling_jian_bian_hao')" prop="partCode')">
                <custom-select
                  url="partList"
                  v-model="form.partCode"
                  :filterable="true"
                  :placeholder="$t('Common.com_please_select')"
                  :props="{ label: 'partCode', value: 'partCode' }"
                  width="100%"
                  @change="changePartName"
                  :dataFilter="partCodeFilter"
                  :filterOptions="{ partType: form.partType, partClass: form.partClass }"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ling_jian_ming_cheng')" prop="partName">
                <el-input v-model="form.partName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.ling_jianSN')" prop="partSn">
                <el-input v-model="form.partSn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.zhi_bao_shi_jian')" prop="warrantyDate">
                <custom-date-picker style="width: 100%" v-model="form.warrantyDate" type="date" :picker-options="pickerOptionDay"></custom-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.cai_gou_dan_hao')">
                <el-input v-model="form.poNum"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_part_inventoryEdit_dialog.lai_liao_dan_hao')">
                <el-input v-model="form.incomingNum"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import mixins from './mixins.js';

export default {
  mixins: [dialogMixins, mixins],

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      pickerOptionDay: {
        firstDayOfWeek: 1,
        disabledDate(day) {
          const today = new Date();
          today.setHours(0);
          today.setMinutes(0);
          today.setSeconds(0);
          today.setMilliseconds(0);
          return day.getTime() > today.getTime();
        },
      },
      form: {
        inBatchNum: '',
        inTime: '',
        partClass: '',
        partType: '',
        partCode: '',
        partName: '',
        partSn: '',
        warrantyDate: '',
        stockFactoryId: '',

        bodyNum: '',
        productCode: '',
        componentCode: '',
        // 采购单号
        poNum: '',
        // 来料单号
        incomingNum: '',

        // country: "",
        // countryCode: "",
        // websiteId: 0,
        // websiteName: ""
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        inTime: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        partCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        partSn: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // partClass: [
        //   {
        //     required: true,
        //     message: '请选择零件类别',
        //
        //
        //   },
        // ],
        // partType: [
        //   {
        //     required: true,
        //     message: '请选择零件类型',
        //
        //
        //   },
        // ],
        // partCode: [
        //   {
        //     required: true,
        //     message: '请填写零件编号',
        //
        //
        //   },
        // ],
        // partName: [
        //   {
        //     required: true,
        //     message: '请输入零件名称',
        //
        //
        //   },
        // ],
        // partSn: [
        //   {
        //     required: true,
        //     message: '请输入零件SN',
        //
        //
        //   },
        // ],
      };
    },
  },
  methods: {
    partCodeFilter(selData, filterOption) {
      let ret = selData;
      if (filterOption.partClass) {
        ret = ret.filter(item => `${item.partClass}` === `${filterOption.partClass}`);
      }

      if (filterOption.partType) {
        ret = ret.filter(item => `${item.partType}` === `${filterOption.partType}`);
      }
      return ret;
    },
    partClassChange() {
      this.form.partCode = '';
      this.form.partName = '';
    },
    partTypeChange() {
      this.form.partCode = '';
      this.form.partName = '';
    },
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        // fix: 因为初始化partClass和partType导致filterOptions变化，从而引起partCode的customSelect的初始化
        // 故用定时器去重置partCode
        setTimeout(() => {
          this.form.partCode = this.model.data.partCode;
        }, 500);
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    changePartCode: function () {
      this.form.partCode = '';
      this.form.partName = '';
    },
    changePartName: function (item) {
      if (item) {
        this.form.partName = item.partName;
      } else {
        this.form.partName = '';
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存编辑
    saveUpdate: function () {
      this.$postJSON(apis.partStockUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', this.form);
      });
    },
  },
};
</script>

<style lang="scss">
.part-inventory-edit-dialog {
  .el-upload--text {
    height: 82px;
    width: 82px;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .upload-bd .el-upload--text {
    width: 178px;
    height: 178px;
    .el-icon-plus {
      font-size: 28px;
    }
  }
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
}
</style>
